<template>
  <div>
    <component :is="headerComponent" :title="pageTitle" />

    <b-container fluid class="pb-5 page-wrap-container">
      <slot v-if="!restrictResponsiveContent" />

      <div v-else class="responsive-warning">
        <i class="responsive-warning-icon fas fa-desktop" />
        <h4 class="responsive-warning-title">
          Para usar la app debes hacerlo desde un navegador de escritorio
        </h4>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isDesktop } from '@/utils';

import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

export default {
  name: 'PageWrap',

  props: {
    pageTitle: {
      type: String,
    },
  },

  computed: {
    ...mapGetters('auth', ['isAdmin']),

    headerComponent() {
      if (this.isDesktop) {
        return DesktopHeader;
      }

      return MobileHeader;
    },

    isDesktop() {
      return isDesktop(this.$vssWidth);
    },

    restrictResponsiveContent() {
      return !this.isDesktop && this.isAdmin;
    },
  },
};
</script>

<style lang="scss">
.page-wrap-container {
  body.-is-standalone & {
    padding-top: 72px;
  }

  .responsive-warning {
    border: 5px solid var(--bf-color-grey);
    text-align: center;
    padding: 20px;

    &-icon {
      font-size: 40px;
      color: var(--bf-color-primary);
      margin-bottom: 18px;
    }

    &-title {
      font-size: 20px;
    }
  }
}
</style>
